import WorksPaginationMix from "./WorksPaginationMix";

export default {
  data() {
    return {
      maxArtistsOnPage: $('#app-wrapper').attr('count_on_page'), //ArtistsListMix
    }
  },
  mixins: [WorksPaginationMix],
  computed: {
    artistsTotal: {
      get() {
        return parseInt(this.$store.getters.artistsTotal);
      },
    },
    lastPage: {
      get() {
        return Math.ceil(this.artistsTotal / this.maxArtistsOnPage)
      },
    },
    artistsOnNextPage: {
      get() {
        if (this.currentPage === this.lastPage) {
          return false
        } else if (this.lastPage - this.currentPage === 1) {
          return this.artistsTotal % this.maxArtistsOnPage
        }

        return this.maxArtistsOnPage
      }
    },
  },

}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/ArtistsPaginationMix.js
// module id = null
// module chunks = 